"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Heading3Icon;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Icon = require("./Icon");

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Heading3Icon(props) {
  return _react2.default.createElement(
    _Icon2.default,
    props,
    _react2.default.createElement("path", { d: "M11,7 C11.5522847,7 12,7.44771525 12,8 L12,16 C12,16.5522847 11.5522847,17 11,17 C10.4477153,17 10,16.5522847 10,16 L10,13 L6,13 L6,16 C6,16.5522847 5.55228475,17 5,17 C4.44771525,17 4,16.5522847 4,16 L4,8 C4,7.44771525 4.44771525,7 5,7 C5.55228475,7 6,7.44771525 6,8 L6,11 L10,11 L10,8 C10,7.44771525 10.4477153,7 11,7 Z M19,7 C19.7865887,7 20.2509345,7.8571835 19.8614991,8.50847393 L19.8,8.6 L17.897,11.137 L18.0117763,11.1748959 C19.1181296,11.5711687 19.9239379,12.5988771 19.9949073,13.8237272 L20,14 C20,15.5976809 18.75108,16.9036609 17.1762728,16.9949073 L17,17 L15,17 C14.4477153,17 14,16.5522847 14,16 C14,15.4871642 14.3860402,15.0644928 14.8833789,15.0067277 L15,15 L17,15 C17.5522847,15 18,14.5522847 18,14 C18,13.4871642 17.6139598,13.0644928 17.1166211,13.0067277 L17,13 L16,13 C15.2134113,13 14.7490655,12.1428165 15.1385009,11.4915261 L15.2,11.4 L17,9 L15,9 C14.4871642,9 14.0644928,8.61395981 14.0067277,8.11662113 L14,8 C14,7.48716416 14.3860402,7.06449284 14.8833789,7.00672773 L15,7 L19,7 Z" })
  );
}